import { render } from "./LogoComponent.vue?vue&type=template&id=576f6989"
import script from "./LogoComponent.vue?vue&type=script&lang=js"
export * from "./LogoComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__